import { Stack, FormControl, FormLabel, HStack, IconButton, Input, Button, Text } from '@chakra-ui/react'
import { IBaseDrawerProps } from '../BaseDrawer';
import { Field, FieldProps, FormikProps } from 'formik';
import { BaseDrawerWithForm } from '../BaseDrawerWithForm';
import { IApiProjectOptionParty } from '../../../models/api/project/options/IApiProjectOptionParty';
import { FiCheck, FiEdit2, FiPlus, FiSquare, FiX } from 'react-icons/fi';
import { boolToString, stringToBool } from '../../../pages/project-parties/ProjectParties';
import { RadioIconButtonGroup, RadioIconButton } from '../../RadioIconButtonGroup/RadioIconButtonGroup';
import { Autocomplete } from '../../Autocomplete/Autocomplete';
import { IApiContactResponse } from '../../../models/api/contact/IApiContactResponse';
import { AutocompleteContactResult } from '../../Autocomplete/AutocompleteContactResult';
import { AutocompleteTradeResult } from '../../Autocomplete/AutocompleteTradeResult';
import { AddContactDrawer } from '../contact/AddContactDrawer';
import { useState, useContext } from 'react';
import toast from 'react-hot-toast';
import Helpers from '../../../Helpers';
import { ApiContext } from '../../../contexts/ApiProvider';
import { AddTradeDrawer } from '../trade/AddTradeDrawer';
import { AutocompleteContactHit } from '../../Autocomplete/AutocompleteContactHit';
import { IApiTradeResponse } from '../../../models/api/trade/IApiTradeResponse';
import { AutocompleteTradeHit } from '../../Autocomplete/AutocompleteTradeHit';

export interface IAddPartyDrawerProps extends Omit<IBaseDrawerProps<IApiProjectOptionParty>, "defaultValue" | "submitAllowed" | "children" | "saveText" | "discardText" | "headerText"> {
    defaultValue?: IApiProjectOptionParty;
    exclusions: string[];
}

export const AddPartyDrawer = (props: IAddPartyDrawerProps) => {
    const [addContact, setAddContact] = useState(false);
    const [addTrade, setAddTrade] = useState(false);
    const { postContact, postTrade } = useContext(ApiContext);
    return (
        <BaseDrawerWithForm
            isOpen={props.isOpen}
            onSubmit={props.onSubmit}
            onDiscard={props.onDiscard}
            defaultValues={props.defaultValue ?? {
                active: true,
                contact: undefined,
                trade: undefined,
                startDate: "",
                aba: null,
                uwn: null,
                bev: null
            }}
            headerText="Beteiligte(n) hinzufügen"
            validateOnBlur={false}
        >
            {({ handleSubmit, errors, touched, isSubmitting, setFieldValue, values }: FormikProps<IApiProjectOptionParty>) => (
                <Stack px="0" spacing="4">
                    <FormControl>
                        <FormLabel htmlFor="contact">
                            <HStack>
                                <Text>Kontakt</Text>
                                <Button leftIcon={<FiPlus />} variant={'outline'} size={'xs'} onClick={() => setAddContact(true)}>erstellen</Button>
                            </HStack>
                        </FormLabel>
                        <Field name="contact" validate={(value: any) => (value === undefined) ? "Kontakt ist erforderlich!" : undefined}>
                            {({ meta: { value } }: FieldProps) => (
                                <>
                                    {(!value && (
                                        /* <ContactSearch onSelect={(c) => setFieldValue("contact", c, true)} exclusions={props.exclusions} maxHeight={"sm"} /> */
                                        <Autocomplete<IApiContactResponse> 
                                            sourceId='contacts' 
                                            indexName='dev_contacts' 
                                            itemTemplate={props => (<AutocompleteContactHit {...props} onClick={() => setFieldValue("contact", props.item, true)} />)} />
                                    )) || (
                                        <HStack justifyContent="space-between">
                                            <AutocompleteContactResult contact={value} />
                                            <IconButton aria-label="bearbeiten" icon={<FiEdit2 />} variant="ghost" onClick={() => setFieldValue("contact", undefined, true)} />
                                        </HStack>
                                    )}
                                </>
                            )}
                        </Field>                   
                    </FormControl>
                    <FormControl isInvalid={(errors.trade && touched.trade) ? true : false}>
                        <FormLabel htmlFor="trade">
                            <HStack>
                                <Text>Gewerk</Text>
                                <Button leftIcon={<FiPlus />} variant={'outline'} size={'xs'} onClick={() => setAddTrade(true)}>erstellen</Button>
                            </HStack>
                        </FormLabel>
                        <Field name="trade" validate={(value: string) => (value !== undefined) ? undefined : "Gewerk ist erforderlich!"}>
                            {({ meta: { value } }: FieldProps) => (
                                <>
                                    {(!value && (
                                        <Autocomplete<IApiTradeResponse> 
                                            sourceId='trades'
                                            indexName='dev_trades'
                                            itemTemplate={props => (<AutocompleteTradeHit {...props} onClick={() => setFieldValue("trade", props.item, true)} />)} />
                                    )) || (
                                        <HStack justifyContent="space-between">
                                            <AutocompleteTradeResult trade={value} />
                                            <IconButton aria-label="bearbeiten" icon={<FiEdit2 />} variant="ghost" onClick={() => setFieldValue("trade", undefined, true)} />
                                        </HStack>
                                    )}
                                </>
                            )}
                        </Field>
                        {/*
                        <Field
                            as={Select}
                            id="trade"
                            name="trade"
                            variant="outline"
                            validate={(value: string) => (value !== undefined) ? undefined : "Gewerk ist erforderlich!"}
                            value={values.trade ? values.trade.id : undefined}
                            onChange={(e: any) => {
                                var value = e.target.value;
                                var index = props.trades.findIndex(t => t.id === value);
                                //console.log(value, index)
                                if(value !== "trade-undefined" && index >= 0) {
                                    setFieldValue("trade", props.trades[index], true);
                                } else {
                                    setFieldValue("trade", undefined, true);
                                }
                            }}
                        >
                            {(values.trade === undefined) && (
                                <option key="trade-undefined" value="trade-undefined">- bitte wählen -</option>
                            )} 
                            {props.trades.sort((a, b) => a.value.localeCompare(b.value)).map(t => (
                                <option key={t.id} value={t.id}>{t.value}</option>
                            ))}
                        </Field>
                        */}
                    </FormControl>
                    <FormControl>
                        <FormLabel htmlFor="startDate">Arbeitsbeginn</FormLabel>
                        <Field 
                            as={Input}
                            id="startDate"
                            name="startDate"
                            variant="outline"
                            type='date'
                            size='md'
                            maxLength={10}
                            //validate={(value: string) => (value && value.length === 10) ? undefined : "Arbeitsbeginn ist erforderlich!"}
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Dokumente</FormLabel>
                        <HStack spacing="5" mt={2}>
                            <RadioIconButtonGroup key="aba" defaultValue={boolToString(values.aba)} size="sm" onChange={(value) => setFieldValue("aba", stringToBool(value), false)}>
                                <RadioIconButton value="true" aria-label="true" icon={<FiCheck fontSize="1.25rem" />} _checked={{ bg: 'green.200' }} />
                                <RadioIconButton value="false" aria-label="false" icon={<FiX fontSize="1.25rem" />} _checked={{ bg: 'red.200' }} />
                                <RadioIconButton value="null" aria-label="null" icon={<FiSquare fontSize="1.25rem" />} />
                            </RadioIconButtonGroup>
                            <FormLabel fontSize="sm" >Arbeitsbeginnanzeige (ABA)</FormLabel>
                        </HStack>
                        <HStack spacing="5" mt={2}>
                            <RadioIconButtonGroup key="uwn" defaultValue={boolToString(values.uwn)} size="sm" onChange={(value) => setFieldValue("uwn", stringToBool(value), false)}>
                                <RadioIconButton value="true" aria-label="true" icon={<FiCheck fontSize="1.25rem" />} _checked={{ bg: 'green.200' }} />
                                <RadioIconButton value="false" aria-label="false" icon={<FiX fontSize="1.25rem" />} _checked={{ bg: 'red.200' }} />
                                <RadioIconButton value="null" aria-label="null" icon={<FiSquare fontSize="1.25rem" />} />
                            </RadioIconButtonGroup>
                            <FormLabel fontSize="sm" >Unterweisungsnachweis (UWN)</FormLabel>
                        </HStack>
                        <HStack spacing="5" mt={2}>
                            <RadioIconButtonGroup key="bev" defaultValue={boolToString(values.bev)} size="sm" onChange={(value) => setFieldValue("bev", stringToBool(value), false)}>
                                <RadioIconButton value="true" aria-label="true" icon={<FiCheck fontSize="1.25rem" />} _checked={{ bg: 'green.200' }} />
                                <RadioIconButton value="false" aria-label="false" icon={<FiX fontSize="1.25rem" />} _checked={{ bg: 'red.200' }} />
                                <RadioIconButton value="null" aria-label="null" icon={<FiSquare fontSize="1.25rem" />} />
                            </RadioIconButtonGroup>
                            <FormLabel fontSize="sm" >Baustellenevaluierung (BEV)</FormLabel>
                        </HStack>
                    </FormControl>
                    <AddContactDrawer 
                        isOpen={addContact} 
                        onDiscard={() => setAddContact(false)}
                        onSubmit={(data) => {
                            var promise = postContact(data);
                            toast.promise(promise, {
                                loading: `Kontakt wird erstellt...`,
                                success: (result) => {
                                    setFieldValue("contact", data, true);
                                    setAddContact(false);
                                    return `Der Kontakt wurde erfolgreich erstellt!`;
                                },
                                error: (code) => Helpers.buildToastErrorMessage(code, `Fehler beim Erstellen des Kontakts!`)
                            });
                            return promise;
                        }}
                    />
                    <AddTradeDrawer 
                        isOpen={addTrade} 
                        onDiscard={() => setAddTrade(false)}
                        onSubmit={(data) => {
                            var promise = postTrade(data);
                            toast.promise(promise, {
                                loading: `Gewerk wird erstellt...`,
                                success: (result) => {
                                    setFieldValue("trade", data, true);
                                    setAddTrade(false);
                                    return `Das Gewerk wurde erfolgreich erstellt!`;
                                },
                                error: (code) => Helpers.buildToastErrorMessage(code, `Fehler beim Erstellen des Gewerks!`)
                            });
                            return promise;
                        }}
                    />
                </Stack>
            )}
        </BaseDrawerWithForm>
    );
}